import {Link, type LinkProps} from "react-router-dom";
import {isNil} from "app/utils/stdlib";
import type {PartialProps} from "app/utils/types";
import type {PropsWithChildren} from "react";

export interface OptionalLinkProps extends PartialProps<LinkProps, "to"> {
  disabled?: boolean;
}

export const OptionalLink = ({children, disabled, to, ...rest}: PropsWithChildren<OptionalLinkProps>) => {
  if (!isNil(to) && !disabled) {
    return (
      <Link to={to} {...rest}>
        {children}
      </Link>
    );
  } else {
    return <>{children}</>;
  }
};
